<template>
    <div class="global-view-info-container">
        <slot></slot>

        <div v-if="isLoading" class="data-loader">
            <img src="../../../static/img/white-loader.svg">
        </div>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        defaultLoading: {
            type: Boolean,
            default: true,
        }
    },

    data (){
        return {
            isLoading: true,
        };
    },

    computed: {

    },

    created (){
        this.isLoading = this.defaultLoading;
    },

    methods: {
        disableLoading (){
            this.isLoading = false;
        }
    },
};
</script>

<style lang="scss">
    .global-view-info-container{
        padding: 30px 40px;
        border-radius: 5px;
        background: linear-gradient(180deg, #222222 41.07%, #111111 100%);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        font-family: Roboto;
        font-style: normal;
        color: #BBBBBB;
        width: 320px;
        height: 420px;
        position: relative;
        .data-loader{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            img{
                animation: rotating 2s linear infinite;
            }
        }
        .big-numbers-title{
            font-weight: normal;
            font-size: 9px;
            line-height: 11px;
            text-transform: uppercase;
            font-family: roboto;
        }
        .big-numbers{
            font-family: roboto-thin;
            font-weight: 200;
            font-size: 90px;
            line-height: 105px;
            text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/partials/global-view-info-container.vue